// Lunch & dinner venues the planner suggests along a day's route. Every
// venue here is one the site already recommends (smørrebrød houses, the
// Danish-classics bodegas, the itinerary's dinner picks, the food halls).
// Coordinates are approximate — good enough to pick "the one nearest to
// where you'll be at 12:30".

const R = 6371;
const toRad = (d) => (d * Math.PI) / 180;
export const kmBetween = (a, b) => {
  const dLat = toRad(b[0] - a[0]);
  const dLng = toRad(b[1] - a[1]);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(a[0])) * Math.cos(toRad(b[0])) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
};

export const LUNCH_VENUES = [
  // the centre
  { name: "Hallernes Smørrebrød", where: "Torvehallerne", coords: [55.6838, 12.5695], tag: "smørrebrød", spot: "torvehallerne" },
  // quick bites — the itinerary's Day 2 lunch (a slice, or bakery goods on the go)
  { name: "Bear Slice", where: "Larsbjørnsstræde 25", coords: [55.67885, 12.56985], tag: "pizza slice", quick: true },
  { name: "Sankt Peders Bageri", where: "Sankt Peders Stræde 29", coords: [55.67913, 12.56921], tag: "bakery goods", quick: true, spot: "sanktpeders" },
  { name: "Restaurant Schønnemann", where: "Hauser Plads 16", coords: [55.68277, 12.57608], tag: "smørrebrød classic" },
  { name: "Aamanns 1921", where: "Niels Hemmingsens Gade 19", coords: [55.68021, 12.57591], tag: "modern smørrebrød" },
  { name: "Det Lille Apotek", where: "Store Kannikestræde 15", coords: [55.6801, 12.5751], tag: "Danish classics" },
  { name: "Gasoline Grill", where: "Landgreven 10", coords: [55.6825, 12.585], tag: "burgers", spot: "gasolinegrill" },
  { name: "Københavner Caféen", where: "Badstuestræde 10", coords: [55.6782, 12.5762], tag: "Danish classics" },
  { name: "Restaurant Puk", where: "Vandkunsten 8", coords: [55.6766, 12.5748], tag: "bodega lunch" },
  { name: "Restaurant Karla", where: "Dantes Plads 1", coords: [55.6745, 12.5712], tag: "Danish classics" },
  { name: "Axelborg Bodega", where: "Axeltorv 1", coords: [55.6755, 12.5645], tag: "bodega lunch" },
  // the harbour
  { name: "Told & Snaps", where: "Toldbodgade 2", coords: [55.67995, 12.59173], tag: "smørrebrød" },
  { name: "Nyhavns Færgekro", where: "Nyhavn 5", coords: [55.6799, 12.5906], tag: "herring buffet" },
  { name: "Nyhavnskroen", where: "Nyhavn 47", coords: [55.6799, 12.5913], tag: "traditional Danish" },
  { name: "Hyttefadet", where: "Nyhavn 25", coords: [55.6803, 12.5898], tag: "Danish classics & fish" },
  // Christianshavn & Refshaleøen
  { name: "Christianshavns Færgecafé", where: "Strandgade 50", coords: [55.6755, 12.59248], tag: "smørrebrød" },
  { name: "Sankt Annæ 8", where: "Wildersgade 52", coords: [55.67386, 12.59136], tag: "smørrebrød & lunch" },
  { name: "Parterre Christianshavn", where: "Overgaden Oven Vandet 90", coords: [55.67529, 12.59609], tag: "café & brunch" },
  { name: "Killer Kebab", where: "Dronningensgade 46", coords: [55.67165, 12.59159], tag: "kebab" },
  { name: "Reffen", where: "Refshalevej 167", coords: [55.693, 12.607], tag: "street food", spot: "reffen", months: [3, 4, 5, 6, 7, 8, 9, 10] },
  { name: "La Banchina", where: "Refshalevej 141", coords: [55.6895, 12.6095], tag: "tiny harbourside kitchen" },
  // Vesterbro & Carlsberg Byen
  { name: "Mother", where: "Kødbyen", coords: [55.6675, 12.5605], tag: "sourdough pizza" },
  { name: "Frk. Barners Kælder", where: "Helgolandsgade 8A", coords: [55.6707, 12.559], tag: "Danish classics" },
  { name: "Restaurant Klubben", where: "Enghavevej 4", coords: [55.67112, 12.54577], tag: "Danish classics" },
  { name: "Wulff & Konstali", where: "Carlsberg Byen", coords: [55.6672, 12.53512], tag: "brunch & lunch" },
  { name: "Aamanns Genbo", where: "Kildepladsen 8", coords: [55.66563, 12.53716], tag: "smørrebrød" },
  { name: "SMAG Carlsberg Byen", where: "Kedelpladsen 2", coords: [55.6659, 12.5357], tag: "seasonal Nordic" },
  // Nørrebro
  { name: "Grød", where: "Jægersborggade 50", coords: [55.6935, 12.543], tag: "porridge bar" },
  { name: "Manfreds", where: "Jægersborggade 40", coords: [55.6932, 12.5435], tag: "veg-forward bistro" },
  { name: "Wulff & Konstali", where: "Sankt Hans Torv 30", coords: [55.6910, 12.5606], tag: "brunch & lunch" },
  { name: "Sebastopol", where: "Sankt Hans Torv 32", coords: [55.6909, 12.5603], tag: "café & brunch" },
  // Østerbro
  { name: "Café Bopa", where: "Løgstørgade 8", coords: [55.7052, 12.5788], tag: "brunch & lunch" },
  { name: "Fiskerestaurant Hooked", where: "Olufsvej 2", coords: [55.7014, 12.5771], tag: "seafood" },
  { name: "Kafe Kapers", where: "Gunnar Nu Hansens Pl. 2", coords: [55.7051, 12.5768], tag: "brunch & lunch" },
  // Frederiksberg
  { name: "Krøgers Familiehave", where: "Pile Allé 18", coords: [55.67124, 12.53106], tag: "garden smørrebrød" },
  { name: "Restaurant Allegade 10", where: "Allegade 10", coords: [55.676, 12.53322], tag: "Danish classics" },
  // Nordhavn & the out-of-centre family attractions (where the centre venues are too far)
  { name: "Wulff & Konstali", where: "Sandkaj 5, Nordhavn", coords: [55.70454, 12.59856], tag: "brunch & lunch" },
  { name: "Den Blå Planet café", where: "on site, Kastrup", coords: [55.6381, 12.6561], tag: "aquarium café" },
];

export const DINNER_VENUES = [
  // the centre
  { name: "La Vecchia Signora", where: "Grønnegade 12", coords: [55.681, 12.583], tag: "Italian" },
  { name: "Restaurant Puk", where: "Vandkunsten 8", coords: [55.6766, 12.5748], tag: "Danish classics" },
  { name: "Restaurant Kronborg", where: "Brolæggerstræde 12", coords: [55.67758, 12.57442], tag: "Danish classics" },
  { name: "Restaurant Grøften", where: "inside Tivoli", coords: [55.6737, 12.5681], tag: "Tivoli classic", needs: "tivoli" },
  // the harbour
  { name: "Nyhavnskroen", where: "Nyhavn 47", coords: [55.6802, 12.5889], tag: "traditional Danish" },
  { name: "Bistro Summér", where: "Nyhavn 65", coords: [55.6803, 12.593], tag: "fine dining" },
  { name: "Broens Gadekøkken", where: "by Inderhavnsbroen", coords: [55.67786, 12.59682], tag: "street food", spot: "broens" },
  // Christianshavn & Refshaleøen
  { name: "Christianshavns Færgecafé", where: "Strandgade 50", coords: [55.6755, 12.59248], tag: "old-school locals' favourite" },
  { name: "Væksthuset", where: "Opera Park", coords: [55.6822, 12.599], tag: "dinner in a greenhouse" },
  { name: "Kadeau", where: "Wildersgade 10B", coords: [55.6738, 12.5915], tag: "two Michelin stars — book ahead" },
  { name: "Reffen", where: "Refshalevej 167", coords: [55.693, 12.607], tag: "street food", spot: "reffen", months: [3, 4, 5, 6, 7, 8, 9, 10] },
  { name: "La Banchina", where: "Refshalevej 141", coords: [55.6895, 12.6095], tag: "tiny harbourside kitchen" },
  // Vesterbro & Carlsberg Byen
  { name: "Mother", where: "Kødbyen", coords: [55.6675, 12.5605], tag: "sourdough pizza" },
  { name: "WarPigs", where: "Flæsketorvet 25", coords: [55.668, 12.5595], tag: "barbecue & beer" },
  { name: "Kødbyens Fiskebar", where: "Flæsketorvet 100", coords: [55.6672, 12.5585], tag: "seafood" },
  { name: "Restaurant Klubben", where: "Enghavevej 4", coords: [55.67112, 12.54577], tag: "Danish classics" },
  { name: "Dolores", where: "Kildepladsen", coords: [55.66533, 12.53708], tag: "Mexican" },
  // Nørrebro
  { name: "Bæst", where: "Guldbergsgade 29", coords: [55.6905, 12.5555], tag: "pizza & charcuterie" },
  { name: "Manfreds", where: "Jægersborggade 40", coords: [55.6932, 12.5435], tag: "veg-forward bistro" },
  // Østerbro
  { name: "Café Bopa", where: "Løgstørgade 8", coords: [55.7052, 12.5788], tag: "neighbourhood café" },
  // Frederiksberg
  { name: "Krøgers Familiehave", where: "Pile Allé 18", coords: [55.67124, 12.53106], tag: "garden restaurant" },
  { name: "Restaurant Allegade 10", where: "Allegade 10", coords: [55.676, 12.53322], tag: "Danish classics" },
];

// Stops that ARE lunch / dinner — a day passing one of these at mealtime
// needs no extra suggestion.
export const LUNCH_COVER = new Set(["smorrebrod", "torvehallerne", "gasolinegrill", "reffen", "broens", "diamondpizza", "koedbyen", "laglace", "tivoli"]);
export const DINNER_COVER = new Set(["reffen", "broens", "koedbyen", "tivoli", "smorrebrod", "gasolinegrill", "diamondpizza"]);

// The n venues nearest to a point, within maxKm. `month` filters seasonal
// venues; `have` (ids on the day) unlocks venues tied to a stop (Grøften
// only makes sense on a Tivoli day).
export const nearestVenues = (list, coords, { n = 2, maxKm = 1.3, month = "any", have = [] } = {}) => {
  if (!coords) return [];
  return list
    .filter((v) => !v.months || month === "any" || v.months.includes(Number(month)))
    .filter((v) => !v.needs || have.includes(v.needs))
    // never suggest a venue that's already a stop on the day
    .filter((v) => !v.spot || !have.includes(v.spot))
    .map((v) => ({ ...v, km: kmBetween(coords, v.coords) }))
    .filter((v) => v.km <= maxKm)
    .sort((a, b) => a.km - b.km)
    .slice(0, n);
};
